function PageHeader(props) {
  /** Render the header for a page. */
  return <h1 className="font-monospace mb-5 text-center">{props.children}</h1>
}

export default PageHeader
